<div class="y3-flex-row y3-flex-align-center y3-flex-justify-space-between y3-explained-button">
  <div class="y3-flex-column y3-flex-justify-content-center">
    <div class="y3-explained-button-title">{{title}}</div>
    <div class="y3-explained-button-description">{{description}}</div>
  </div>
  <div>
    <mat-icon class="y3-explained-button-button" style="font-size: 40px">chevron_right</mat-icon>
  </div>
</div>
